import { createApi} from '@reduxjs/toolkit/query/react';
import { pyrotchBaseUrl } from '../axios/AxiosInstance';
import { axiosBaseQuery } from '../axios/AxiosInstance';

export interface responseUser {
  id?: number;
  name?: string;
  email?: string;
  employeeId?: string;
  internalEmail?: string;
  mobileNumber?: string;
  jwtToken: any;
  profilePhoto: any;
  filePath: any;
}

export interface UpdateProfileRequest {
  name?: string;
  email?: string | null;
  employeeId?: string | null;
  internalEmail?: string | null;
  mobileNumber?: string | null;
}

export const ProfileApi = createApi({
  reducerPath: 'profileApi',
  tagTypes: ['Profile'],
  baseQuery: axiosBaseQuery({
    baseUrl: `${pyrotchBaseUrl}v1/`,
  }),
  endpoints: (builder) => ({
    
    uploadProfilePhoto: builder.mutation<void, any>({
      query: (data) => {
        const formData = new FormData();
        formData.append("file", data);
        return {
          url: 'user/profile-photo',
          data: formData,
          method: 'POST',
          headers: {
            "Content-Type": "multipart/form-data", 
          },
        };
      },
    }),

     changePassword: builder.mutation<void, any>({
      query: (data) => {
        return {
          url: `user/change-password?oldPassword=${data.currentPassword}&newPassword=${data.newPassword}`,
          method: 'POST',
        };
      },
    }),

    getUser : builder.query<responseUser, void>({
      query: () => ({
        url: 'user',
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      providesTags: ['Profile'],
    }),

    updateProfileDetails: builder.mutation<responseUser, UpdateProfileRequest>({
      query: (data) => ({
        url: 'user',
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Profile'],
    }),
  }),
});

export const { useUploadProfilePhotoMutation , useGetUserQuery, useChangePasswordMutation, useUpdateProfileDetailsMutation  } = ProfileApi;
